import { effect, untracked } from '@angular/core';

/**
 * Runs `load` once per distinct non-null context key (e.g. `creatorId` or `briefId|creatorId`).
 * Skips re-fetch when the same IDs are already loaded; still re-runs when IDs change.
 */
export function autoLoadOnContextKey(getKey: () => string | null, load: () => void): void {
  let lastKey: string | null = null;
  effect(() => {
    const key = getKey();
    if (!key || key === lastKey) {
      return;
    }
    lastKey = key;
    untracked(() => load());
  });
}
